<template>
    <div class="card card-default" v-if="list.length">
        <!-- Update Import Modal -->
        <div class="modal" id="update-import-modal" tabindex="-1" role="dialog">
            <div class="modal-dialog">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">
                            Import {{ updatingImport.team_name }} Again
                        </h5>
                    </div>

                    <div class="modal-body">
                        <label for="database">Database:</label>
                        <select name="database" id="database" class="form-control" v-model="updatingImport.database"
                                :class="{'is-invalid': updatingImport.errors.has('host')}">
                            <option v-for="db in databases" :value="db.name">{{ db.name }}</option>
                        </select>
                        <span class="invalid-feedback" v-show="updatingImport.errors.has('host')">
                            {{ updatingImport.errors.get('host') }}
                        </span>
                    </div>

                    <!-- Modal Actions -->
                    <div class="modal-footer">
                        <button type="button" class="btn btn-default" data-dismiss="modal">Go Back</button>

                        <button type="button" class="btn btn-warning" @click="updateImport()">
                            Confirm Database and Import
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <div class="card-header">Imports</div>

        <table class="table table-striped">
            <thead>
            <tr>
                <th>Database</th>
                <th>Team</th>
                <th>Status</th>
                <th></th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="item in list" :key="item.id">
                <td>
                    {{ item.id }} -> {{ item.database }}
                </td>
                <td>
                    ({{ item.team_id }}) {{ item.team_name }}
                    <span v-if="item.with_project_management" class="badge badge-info">PM</span>
                </td>
                <td>{{ item.status }}</td>
                <td>
                    <button class="btn btn-outline-warning" @click="updateModal(item)">
                        <i class="fa fa-history"></i>
                    </button>
                </td>
            </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
    export default {
        name   : 'importer-list',
        props  : ['databases'],
        data() {
            return {
                list          : [],
                updatingImport: new SparkForm({
                    team_name: null
                }),
            }
        },
        created() {
            Bus.$on('loadImports', () => {
                return this.loadImports();
            });
            this.loadImports();
        },
        methods: {
            loadImports() {
                axios.get(route('legacy-migration.import.index'))
                    .then(({data}) => this.list = data);
            },

            updateModal(item) {
                this.updatingImport = new SparkForm({...item});

                $('#update-import-modal').modal('show');
            },

            updateImport(item) {
                Spark.put(route('legacy-migration.import.update'), this.updatingImport)
                    .then(({data}) => Bus.$emit('loadImports'));

                $('#update-import-modal').modal('hide');
            },
        }
    }
</script>
